<template>
  <div :class="{ 'sold-out': isSoldOut }">
    <div class="px-6">
      <div class="border border-black-light-2 rounded">
        <div class="px-4 py-2 bg-black-light-1">
          <div class="flex items-baseline">
            <span class="fs-32 font-medium pr-2">{{ tripDate }}</span>
            <span class="trip-month">{{ tripMonth }} {{ tripYear }}</span>
            <div class="flex-1 text-right self-center">
              <div class="flex-none flex items-center justify-end fs-14">
                <svg
                  width="24"
                  height="24"
                  class="flex-none mr-2"
                  :class="{ 'opacity-50': isSoldOut }"
                >
                  <use xlink:href="/img/sprite.svg#ic_calendar"></use>
                </svg>
                {{ trip.itineraries.itinerary_length + 1 }}D /
                {{ trip.itineraries.itinerary_length }}N
              </div>
            </div>
          </div>
        </div>

        <div class="px-4 py-6">
          <h4 class="text-base font-medium mb-2">
            {{ trip.itineraries.name }}
          </h4>
          <div class="flex flex-wrap items-center mb-4">
            <div class="flex-none flex items-center fs-14">
              <svg
                width="24"
                height="24"
                class="flex-none mr-2"
                :class="{ 'opacity-50': isSoldOut }"
              >
                <use xlink:href="/img/sprite.svg#ic_diving"></use>
              </svg>
              {{ trip.itineraries.dive_number }} dives
            </div>
          </div>

          <div
            class="mb-4 flex"
            :class="trip.discount ? 'justify-between' : 'justify-end'"
          >
            <div class="flex-1 text-left self-end" v-if="trip.discount">
              <div
                class="discount-tag"
                v-if="
                  !trip.discount_method || trip.discount_method === 'fix_amount'
                "
              >
                -{{ trip.currency }}{{ trip.discount }} off
              </div>
              <div
                class="discount-tag"
                v-else-if="trip.discount_method === 'percentage'"
              >
                -{{ trip.discount }}% discount
              </div>
            </div>
            <div class="text-right">
              <div
                v-if="trip.discount"
                class="text-black-light-5 fs-14 line-through"
              >
                <currency-context>
                  <template v-slot="{ convert }">
                    <span
                      class="font-medium"
                      v-text="convert(lowestPrice.real_price)"
                    ></span>
                  </template>
                </currency-context>
              </div>
              <div>
                from
                <currency-context>
                  <template v-slot="{ convert }">
                    <span
                      class="fs-20 font-medium"
                      v-text="convert(lowestPrice.final_price)"
                    ></span>
                  </template>
                </currency-context>
              </div>
            </div>
          </div>

          <div class="flex gap-4 mb-4">
            <itinerary-details
              @enquire="handleEnquire"
              class="itinerary-detail-button input-tall"
              :trip="trip"
              :supplier="supplier"
              :selected-time="selectedTime"
            />

            <button
              type="button"
              class="btn btn-secondary input-tall enquire-button sm:w-full"
              v-if="!isSoldOut"
              @click="handleEnquire"
            >
              Select cabin
            </button>
          </div>

          <div
            class="font-medium"
            :class="isSoldOut ? 'text-center' : 'text-right'"
          >
            <span :class="cabinAvailability.class">
              {{ cabinAvailability.text }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItineraryDetails from "./ItineraryDetails";
import TripMixin from "./TripMixin";
import CurrencyContext from "../../components/core/CurrencyContext";

export default {
  mixins: [TripMixin],
  components: {
    ItineraryDetails,
    CurrencyContext,
  },
  props: ["trip", "selectedTime", "supplier"],
  methods: {
    handleEnquire() {
      this.$emit("enquire-click");
    },
  },
};
</script>

<style scoped>
.trip-month {
  position: relative;
  top: -5px;
}

.itinerary-detail-button ::v-deep .btn {
  height: 48px;
}

@media (max-width: 600px) {
  .addons {
    background-color: var(--blue-light-4);
    margin-bottom: 0.75rem;
    border-width: 1px;
    border-style: solid;
  }

  .addons-discount {
    border-color: var(--purple-light-3);
    background-color: var(--discount-basis-bg);
  }

  .addons-blue {
    border-color: var(--blue-light-3);
    background-color: var(--info-basis-bg);
  }

  .addons-green {
    border-color: var(--green-light-3);
    background-color: var(--success-basis-bg);
  }

  .addons-marine {
    border-color: var(--marine-light-3);
    background-color: var(--marine-light-1);
  }

  .discount-tag {
    display: inline-block;
    background: var(--discount-primary);
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 14px;
  }
}
</style>
